import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { PreventiveMaintenanceAssignFormService } from '..';
import { ExceptionHelper } from '../../../../helper';
import { WarningModalComponent } from '../../../shared/components/warning-modal/warning-modal.component';
import { PreventiveMaintenanceService } from '../preventive-maintenance.service';

@Component({
  selector: 'app-preventive-maintenance-pdf-summary',
  templateUrl: './preventive-maintenance-pdf-summary.component.html',
  styleUrls: ['./preventive-maintenance-pdf-summary.component.css']
})
export class PreventiveMaintenancePdfSummaryComponent implements OnInit {

  equipmentId: string;
  pmId: string;
  files: any[];
  dataTable: any;
  bsModalRef: BsModalRef;
  isDownloading = false;
  isRedirect = true;

  constructor(
    private assignFormService: PreventiveMaintenanceAssignFormService,
    private modalService: BsModalService,
    private route: ActivatedRoute,
    private router: Router,
    private exception: ExceptionHelper,
    private chRef: ChangeDetectorRef,
    private translate: TranslateService,
    private pmService: PreventiveMaintenanceService
  ) {
    this.translate.setDefaultLang('en-us');
    this.route.params.subscribe(params => {
      this.equipmentId = params.equipmentId;
      this.pmId = params.pmId;
      console.log(params);
      
    });
  }

  ngOnInit() {
    this.getEquipmentDetail();
    
  }

  getEquipmentDetail() {

    this.pmService.getPMPdf(this.pmId, this.equipmentId).subscribe(x=>{
      this.files = x.models
    }, err => {
        this.files = [];
      }, () => {
        if ($.fn.dataTable.isDataTable('#pdfDataTable')) {
          $('#pdfDataTable').DataTable().destroy();
        }
  
        this.chRef.detectChanges();
        const table: any = $('#pdfDataTable');
        table.DataTable();
      });
    }
  download(formId, isSpecial, eqDetailId){
    this.isDownloading = true;
    this.assignFormService.getForm(formId, 1, this.pmId, this.equipmentId ).subscribe(data => {
      const blob = new Blob([data.file], { type: 'application/pdf' });
      saveAs(blob, data.fileName);
      this.isDownloading = false;
      this.chRef.detectChanges();
    }, err => {
      this.isDownloading = false;
      this.exception.showError(err, 'showDanModalBtn');
      // this.redirect = false;
    });
  }
  delete(fileId) {
     
    const initialState = {
      message: this.translate.instant('header.pdf'),
      ok: () => {
        this.pmService.deletePdf(this.pmId, this.equipmentId, fileId).subscribe(data => {
          this.router.navigate(['../'], {relativeTo: this.route}).then((()=>{
            
    this.getEquipmentDetail();
          }));
          this.bsModalRef.hide();
        });
      }
    };
    this.bsModalRef = this.modalService.show(WarningModalComponent, { initialState });

  }

 
}


// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/preventive-maintenance/preventive-maintenance-pdf-summary/preventive-maintenance-pdf-summary.component.ts